import { useState, useEffect } from 'react'
import { FormHelperText, TextField, Grid, Box, Typography } from '@mui/material'

function PersonalDetails ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    onFormDataChange({ [name]: value })
  }

  useEffect(() => {
    const newErrors = {}
    const today = new Date()
    const minAgeDOB = new Date(today.getFullYear() - 10, today.getMonth(), today.getDate())
    const dobDate = formData.dob ? new Date(formData.dob) : null

    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required'
    if (!formData.preferredName.trim()) newErrors.preferredName = 'Preferred name is required'
    if (!formData.surname.trim()) newErrors.surname = 'Surname is required'
    if (!formData.dob) {
      newErrors.dob = 'Date of Birth is required'
    } else if (dobDate > today) {
      newErrors.dob = 'Date of Birth cannot be in the future'
    } else if (dobDate > minAgeDOB) {
      newErrors.dob = 'Please enter a valid Date of Birth'
    }
    if (!formData.countryOfBirth.trim()) newErrors.countryOfBirth = 'Country of Birth is required'

    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Personal Details</Typography>
      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label='First Name'
            name='firstName'
            variant='outlined'
            fullWidth
            value={formData.firstName}
            onChange={handleChange}
            error={!!errors.firstName && showErrors}
            helperText={showErrors ? errors.firstName : ''}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label='Preferred Name'
            name='preferredName'
            variant='outlined'
            fullWidth
            value={formData.preferredName}
            onChange={handleChange}
            error={!!errors.preferredName && showErrors}
            helperText={showErrors ? errors.preferredName : ''}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label='Surname'
            name='surname'
            variant='outlined'
            fullWidth
            value={formData.surname}
            onChange={handleChange}
            error={!!errors.surname && showErrors}
            helperText={showErrors ? errors.surname : ''}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label='NHI Number'
            name='nhiNumber'
            variant='outlined'
            fullWidth
            value={formData.nhiNumber}
            onChange={handleChange}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label='Date of Birth'
            name='dob'
            type='date'
            slotProps={{ inputLabel: { shrink: true } }}
            fullWidth
            value={formData.dob}
            onChange={handleChange}
            error={!!errors.dob && showErrors}
            helperText={showErrors ? errors.dob : ''}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label='Country of Birth'
            name='countryOfBirth'
            variant='outlined'
            fullWidth
            value={formData.countryOfBirth}
            onChange={handleChange}
            error={!!errors.countryOfBirth && showErrors}
            helperText={showErrors ? errors.countryOfBirth : ''}
            required
          />
          <FormHelperText>
            If you were not born in New Zealand – copies of your passport will have to be provided showing residency status.
          </FormHelperText>
        </Grid>
      </Grid>
    </Box>
  )
}

export default PersonalDetails
